// extracted by mini-css-extract-plugin
export default {"progress-bar":"ProgressBar-module__progress-bar___EbkJk","progress-bar_past":"ProgressBar-module__progress-bar_past___pTBIX"};